export function isNoChargeOrder(order: {
  payment?: { collection?: string };
  pricing?: { buyerGrandTotalCents?: number };
}): boolean {
  return (
    order.payment?.collection === "none" &&
    order.pricing?.buyerGrandTotalCents === 0
  );
}
